import React from 'react'
import { connect } from 'react-redux'
import { getInvestments } from 'services/user'
import Navigation from 'support/navigation'
import { getGroups } from 'services/challenge_steps'
import {
  showPopupDialog,
  showPopupSuccessSnackbar,
  showPopupErrorSnackbar,
} from 'support/popup_dialogs'
import ErrorSubmitModal from './dialogs/ErrorSubmitContainer'
import ConfirmEvaluatorDeleteIdeaModal from './dialogs/ConfirmEvaluatorDeleteContainer'
import ConfirmSubmitModalIdeaAddBulkSME from './dialogs/ConfirmSubmitModalIdeaAddBulkSME'
import View from './View'
import { getInnovateChallengeActiveTypes, getInnovateChallengeAllList } from 'services/innovate/challenge'
import { getInnovateChallengeTaggedIdeaList, deleteAssignedEvaluatorIntoIdeaDetail, deleteAllAssignedEvaluatorIntoIdea } from 'services/innovate/idea'
import i18n from 'support/i18n'
import { getInnovateChallengeFilterList } from 'services/innovate/challenge'

const mapStateToProps = state => {
  return {
    ideas: state.data.user.investments.ideas,
    userEmail: state.data.user.userEmail,
    isAdmin: state.data.user.admin,
    // listInnovateChallenge:state.data.InnovateChallenge.listInnovateChallenge,
    listInnovateChallenge:state.data.InnovateChallenge.filterListInnovateChallenge,
    innovateCategoryTypes:state.data.InnovateChallenge.innovateCategoryTypes,
    listCommunitesChallenge:state.data.InnovateChallenge.listInnovateCommunitesChallenge,
    InnovateGetChallengeTaggedIdeaListIsLoading:state.data.InnovateIdea.innovateGetChallengeTaggedIdeaListIsLoading,
    postInnovateIdeaAddBySMEGroupsIsLoading:state.data.InnovateIdea.postInnovateIdeaAddBySMEGroupsIsLoading,
    InnovateGetChallengeTaggedIdeaList:state.data.InnovateIdea.innovateGetChallengeTaggedIdeaList,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    getCommunitesAsGroup : ()=> dispatch(getGroups()),

    getInnovateChallengeAllListFn: () => {
      dispatch(getInnovateChallengeAllList())
    },

    getInnovateChallengeFilterListFn: (challengeStatus, offset,limit,enableIsHackathon) => {
     
      dispatch(getInnovateChallengeFilterList({challengeStatus,offset ,limit , enableIsHackathon}))

    },

    getInnovateChallengeActiveTypesFn: () => {
      dispatch(getInnovateChallengeActiveTypes())
    },
    getInnovateChallengeTaggedIdeaListFn: (challengeKey) => {
      dispatch(getInnovateChallengeTaggedIdeaList(challengeKey))
    },

    deleteAssignedEvaluatorIntoIdeaFn : (deleteEvaluatorlistParams, onSuccessCallback, onFailureCallback)=>{
      const onSuccess = () => {
        // Refresh the tagged idea list for the current challenge
        if (deleteEvaluatorlistParams?.challengeKey) {
          dispatch(getInnovateChallengeTaggedIdeaList(deleteEvaluatorlistParams.challengeKey))
        }
        if (onSuccessCallback) onSuccessCallback()
      }
      const onFailure = (error) => {
        if (onFailureCallback) onFailureCallback(error)
      }
      dispatch(deleteAssignedEvaluatorIntoIdeaDetail(deleteEvaluatorlistParams, onSuccess, onFailure))
    },

    //all evaluator delete fn
    deleteAllAssignedEvaluatorIntoIdeaFn : (deleteEvaluatorlistParams, onSuccessCallback, onFailureCallback)=>{
      console.log("deleteEvaluatorlistParams==> ALL Assign ",deleteEvaluatorlistParams )
      const onSuccess = () => {
        // Refresh the tagged idea list for the current challenge
        if (deleteEvaluatorlistParams?.challengeKey) {
          dispatch(getInnovateChallengeTaggedIdeaList(deleteEvaluatorlistParams.challengeKey))
        }
        if (onSuccessCallback) onSuccessCallback()
      }
      const onFailure = (error) => {
        if (onFailureCallback) onFailureCallback(error)
      }
      dispatch(deleteAllAssignedEvaluatorIntoIdea(deleteEvaluatorlistParams, onSuccess, onFailure))
    },

    //bulk auto assign Evaluator
    postInnovateIdeaAddBySMEGroupsFn: (ideaBulkSMEAddParams, otherParams)=>{
      showPopupDialog(<ConfirmSubmitModalIdeaAddBulkSME ideaBulkSMEAddParams={ideaBulkSMEAddParams}  />, dispatch)
      // console.log("AddEvaluatorParams==>params", AddEvaluatorParams)

      // const onSuccess = data => {
      //   // console.log("🚀 ~ onSuccess ~ data Evaluator:", data,data?.ideaIdKey)
      //   // const  objpass = {
      //   //   ideaIdKey:data?.ideaIdKey,
      //   //   userEmail:data?.userEmail,
      //   //   businessSCFlag: data?.businessScoreCardFlag,
      //   // }                                                         
      //   const message='The Evaluator assignment has been successfully completed.'
      //   // same page auto update list after success 
       
      //   // if(data?.ideaIdKey === null){
      //   //   dispatch(getListEvaluatorAssignedForIdea(AddEvaluatorParams?.ideaIdKey))
      //   // }else{
      //   //   dispatch(getListEvaluatorAssignedForIdea(data?.ideaIdKey))
      //   // }
      //   // dispatch(getUserValidateEvaluatorScorecardRole(objpass))
      //   showPopupSuccessSnackbar(message, dispatch)
      // }

      // const onFailure = ({ data }) => {
      //   const messageTag =
      //     data && data.error && data.error.error
      //       ? `BACKEND_ERRORS.${data.error.error}`
      //       : 'BACKEND_ERRORS.UNEXPECTED'
      //   showPopupDialog(<ErrorSubmitModal description={i18n.t(messageTag)} />, dispatch)
      // }
      // dispatch(postInnovateIdeaAddBySMEGroups(AddEvaluatorParams,onSuccess,onFailure))
    }, 

  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(View)
